import React, { useState } from 'react';
import { FaCheckCircle, FaEnvelopeOpenText } from 'react-icons/fa';
import { auth } from '../../firebase-config';
import { useNavigate } from 'react-router-dom';
import { sendEmailVerification } from 'firebase/auth';

function OTP({ email }) {
  const [checking, setChecking] = useState(false);
  const [status, setStatus] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleVerificationCheck = async () => {
    const user = auth.currentUser;

    if (!user) {
      setStatus('User not logged in');
      return;
    }

    setChecking(true);
    await user.reload();

    if (user.emailVerified) {
      navigate('/verify-account/kyc');
    } else {
      setStatus('Account not verified');
      setTimeout(() => setStatus(''), 5000);
    }

    setChecking(false);
  };

  const handleResendVerification = async () => {
    try {
      const user = auth.currentUser;
      if (user) {
        await sendEmailVerification(user);
        setMessage('Verification email has been resent. Please check your inbox.');
      } else {
        setMessage('You must be logged in to resend the verification email.');
      }
    } catch (error) {
      setMessage(`Error: ${error.message}`);
    }
  };

  return (
    <div className="otp-container">
      <div className="otp-card">
        <FaEnvelopeOpenText className="otp-icon" />
        <h1 className="otp-heading">Verify Your Account</h1>
        <p className="otp-text">
          A verification link has been sent to <strong>{email}</strong>. Please check your email and click the link to complete your registration.
        </p>

      <div className="buttons">

        <a href={`mailto:${email}`} className="otp-button">
          <FaCheckCircle className="icon-inline" /> Open Email App
        </a>

        <button
          onClick={handleVerificationCheck}
          className="otp-verify-button"
          disabled={checking}
        >
          {checking ? 'Checking...' : 'Check Verification'}
        </button>

      </div>

        {status && <p className="otp-status">{status}</p>}

        {message && <p className="otp-message">{message}</p>}

        <p className="otp-resend" onClick={handleResendVerification}>
          Didn't receive an email? <a href="#">Resend Verification Link</a>
        </p>
      </div>
    </div>
  );
}

export default OTP;
